(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var OPEN = 300, CLOSE = 240, EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

    function reduced() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function animate(row, opening) {
      var body = row.querySelector('.pdp-faqs__body');
      if (!body) return;
      if (row._faqAnim) row._faqAnim.cancel();

      var from = opening ? 0 : body.scrollHeight;
      var to = opening ? body.scrollHeight : 0;

      row._faqAnim = body.animate(
        [{ height: from + 'px' }, { height: to + 'px' }],
        { duration: opening ? OPEN : CLOSE, easing: EASE }
      );
      row._faqAnim.onfinish = function () {
        row._faqAnim = null;
        body.style.height = '';
        if (!opening) row.open = false;
      };
      row._faqAnim.oncancel = function () { body.style.height = ''; };
    }

    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.pdp-faqs__q');
      if (!summary) return;
      var row = summary.parentElement;
      if (!row || !row.classList.contains('pdp-faqs__row')) return;
      if (reduced()) return;                 // let the native toggle do it

      if (row.open) {
        // Defer the close so the body is still measurable, and so an
        // interrupted double-click converges instead of leaving it half-shut.
        e.preventDefault();
        animate(row, false);
      } else {
        row.open = true;
        e.preventDefault();
        animate(row, true);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
